// This script dynamically shows/hides the "store availability" snippet (Pickup available at...)
// When qty exceeds that in stock, local pickup snippet will disappear
// When qty meets or is lower than that in stock, local pickup snippet appears again


;(function(){
  // Core logic: reads the latest DOM each time
  function updatePickup() {
    const section   = document.querySelector('[data-section-type="product_page"]');
    if (!section) return;

    const input     = section.querySelector('input[name="quantity"]');
    const container = section.querySelector('[data-stock]');
    if (!input || !container) return;

    const stock     = parseInt(container.dataset.stock, 10) || 0;
    const requested = Math.max(1, parseInt(input.value, 10) || 1);

    container.style.display = (requested <= stock ? '' : 'none');
  }

  // Run once on load
  document.addEventListener('DOMContentLoaded', updatePickup);

  // Catch manual typing / pasting
  document.addEventListener('input', function(e){
    if (e.target.matches('input[name="quantity"]')) updatePickup();
  });

  // Catch +/– button clicks anywhere on the page
  document.addEventListener('click', function(e){
    // if the click was on or inside a button next to our quantity field
    if (e.target.closest('button')) updatePickup();
  });

  // Also re-run when Shopify swaps out the section (e.g. variant change)
  document.addEventListener('shopify:section:load', updatePickup);
  
})();



